export default "__VITE_ASSET__0deDPZO6__"